(function(window,$) {

	normalizeHero();
	$(window).on('load resize orientationchange', function() {
		normalizeHero();
	});

	function normalizeHero() {
		var viewportHeight = $(window).height(),
			headerHeight = $('#header').outerHeight(true),
			navHeight = $('.app_nav').outerHeight(true);
		$('.app_my-jbl-headphones-app').css('height', (viewportHeight-headerHeight-navHeight)+'px');
	}

})(window,jQuery);
